import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import LandingPage from './components/landingPage';

// Crear un tema personalizado similar a los colores de Tailwind
const theme = createTheme({
  palette: {
    primary: {
      light: '#4791db',
      main: '#1976d2', // Azul principal similar al de Tailwind
      dark: '#115293',
      contrastText: '#fff',
      50: '#e3f2fd', // Color muy claro para fondos sutiles
    },
    secondary: {
      light: '#ff4081',
      main: '#f50057', // Rosa/rojo para acentos
      dark: '#c51162',
      contrastText: '#fff',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee', 
      300: '#e0e0e0',
      800: '#424242',
      900: '#212121',
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
    },
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    button: {
      textTransform: 'none', // Quita las mayúsculas predeterminadas en botones
      fontWeight: 600,
    }
  },
  shape: {
    borderRadius: 8, // Bordes redondeados por defecto, similar a Tailwind
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
          '&:hover': {
            boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
          },
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#115293',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          overflow: 'hidden',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 12,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Esto normaliza los estilos CSS entre navegadores */}
      <LandingPage />
    </ThemeProvider>
  );
}

export default App;